/**
 * 按 prefix 生成 CollabCore 六接口 Service
 * 完整路径：POST /api/v1{prefix}/{action}
 */

import { dict } from '../config'
import request from '@/shared/api/request'
import type { CollabService } from '../types/crud'
import type { DeleteResult, ListQuery, PageQuery, PageResult } from '../types/contract'

/**
 * 创建 CollabCore CRUD 服务
 * @param prefix 相对 /api/v1 的路径，如 '/demo/goods'
 */
export function createCollabService<T = Record<string, unknown>>(
  prefix: string,
): CollabService<T> {
  const normalizedPrefix = prefix.startsWith('/') ? prefix : `/${prefix}`
  const { api } = dict

  return {
    page(params?: PageQuery) {
      return request.post<PageResult<T>>(`${normalizedPrefix}/${api.page}`, params ?? {})
    },
    list(params?: ListQuery) {
      return request.post<T[]>(`${normalizedPrefix}/${api.list}`, params ?? {})
    },
    add(data: Partial<T>) {
      return request.post<T>(`${normalizedPrefix}/${api.add}`, data)
    },
    update(data: Partial<T> & { id: number }) {
      return request.post<T>(`${normalizedPrefix}/${api.update}`, data)
    },
    delete(data: { ids: number[] }) {
      return request.post<DeleteResult>(`${normalizedPrefix}/${api.delete}`, data)
    },
    info(id: number) {
      return request.get<T>(`${normalizedPrefix}/${api.info}`, { params: { id } })
    },
  }
}

export default createCollabService
